// extracted by mini-css-extract-plugin
module.exports = {"customShimmer":"shimmerbox_customShimmer__3Pfr0","placeholderShimmer":"shimmerbox_placeholderShimmer__1XDaP"};